import Axios from 'axios'
import * as React from 'react'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import {CsSelector} from '../../core/components/Controls/CsSelector'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {config} from '../../core/reducers/config'
import {Feature} from '../../core/models'
import {LocationSelector} from '../App/LocationSelector'

interface Props {}

interface State {
  loading: boolean
  file?: AttachmentInfo
  dataCS: CoordinateSystem
  afterSuccess: boolean
  error: string
  selectedLocation?: Feature
  selectedSettlemet?: Feature
  locationPlans: Feature[]
  Cp1251: boolean
  overwrite: boolean
}

export class CPImport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      dataCS: CoordinateSystem.BG2005CAD,
      error: '',
      locationPlans: [],
      Cp1251: true,
      overwrite: false
    }
  }
  getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={this.state.dataCS}
        onChange={s => this.setState({...this.state, error: '', dataCS: s})}
        className="form-control"
      />
    )
  }
  getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (this.state.file) {
      adds[this.state.file.name] = this.state.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.dxf,.dwg'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            this.setState({...this.state, file: file, error: ''})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }

  getLoactionSelector() {
    return (
      <LocationSelector
        onSettlementsChange={(locs, selectedSettlemet?: Feature, selectedLocation?: Feature) => {
          this.setState(
            {...this.state, selectedLocation: selectedLocation, selectedSettlemet: selectedSettlemet, loading: true},
            () => {
              if (selectedLocation) {
                this.setState({...this.state, loading: false})
              } else {
                this.setState({...this.state, locationPlans: [], loading: false})
              }
            }
          )
        }}
        selectedLocation={this.state.selectedLocation}
        selectedSettlemet={this.state.selectedSettlemet}
      />
    )
  }
  getEncodingSelector = () => {
    return (
      <input
        type="checkbox"
        checked={this.state.Cp1251}
        onChange={() => this.setState({...this.state, Cp1251: !this.state.Cp1251})}
      ></input>
    )
  }

  getOverwriteSelector = () => {
    return (
      <input
        type="checkbox"
        checked={this.state.overwrite}
        onChange={() => this.setState({...this.state, overwrite: !this.state.overwrite})}
      ></input>
    )
  }

  getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }
  getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!this.state.file}
        onClick={() => {
          const formData = new FormData()
          formData.append('File', this.state.file!.file!, this.state.file!.name)
          formData.append('DataCS', this.state.dataCS)
          formData.append('LocationId', this.state.selectedLocation!.getId())
          formData.append('Cp1251', this.state.Cp1251.toString())
          formData.append('Overwrite', this.state.overwrite.toString())
          this.setState({...this.state, loading: true}, () => {
            Axios.post(config.getConfig().urls.importCP, formData, {
              headers: {'Content-Type': `multipart/form-data;`}
            })
              .then(r => {
                this.setState({...this.state, afterSuccess: true, error: '', loading: false})
              })
              .catch(error => {
                if (error.response && error.response.data && error.response.data) {
                  this.setState({...this.state, error: error.response.data})
                } else {
                  this.setState({...this.state, error: 'Възникна грешка ' + error.message, loading: false})
                }
              })
          })
        }}
      >
        Импорт (данните се записват без потвърждение в базата)
      </button>
    )
  }
  afterSuccess() {
    return (
      <div>
        <div className="success-div">Успешен импорт</div>
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined})
          }}
        >
          Нов импорт
        </button>
      </div>
    )
  }

  onerror() {
    return (
      <div className="error-div">
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined, error: ''})
          }}
        >
          Нов импорт
        </button>
        {this.state.error}
      </div>
    )
  }
  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '80%', overflow: 'auto'} as React.CSSProperties}>
        {this.state.afterSuccess ? (
          this.afterSuccess()
        ) : this.state.error ? (
          this.onerror()
        ) : (
          <div style={{position: 'relative'}}>
            <OverlayLoader show={this.state.loading}></OverlayLoader>
            <div style={{textAlign: 'center'}}>
              Импорт на допълнителна улична регулация. Очаква се DXF/DWG файл.
              <br />
              Фаил с примерни линии и обекти можете да намерите <a href="/resources/samples/kadaster.dwg">ТУК</a>
            </div>
            {this.getContainer(this.getLoactionSelector(), 'Населено място и квартал', `10px 0px`)}
            {this.getContainer(this.getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
            {this.getContainer(this.getProjectionSelector(), 'Координатна система на данните от файла', `10px 0px`)}
            {this.getContainer(this.getOverwriteSelector(), 'Презаписване на данните', `10px 0px`)}
            {this.getExecuteButton()}
          </div>
        )}
      </div>
    )
  }
}
